import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { searchCourses, searchInstructors } from '../common/api';
import { getAllDepartments } from '../common/utils';

import '../styles/SearchResultWrapper.css';

class SearchResultWrapper extends Component {
    constructor(props) {
        super(props);
        // this._updateDimensions = this._updateDimensions.bind(this);
        this.state = { query: props.query, courses: [], instructors: [], hasNextCourse: false, hasNextInstructor: false,
            coursePage: 1, instructorPage: 1, initCourses: false, initInstructors: false };
    }

    _appendCourses(event) {
        let target = (event) ? event.target : null;
        if (target) {
            if (target.classList.contains('searching')) return;
            target.className += ' searching';
        }
         const gen = (elem) => {
            return (res) => {
                if (elem) elem.classList.remove('searching');
                if (!res) return;
                let _courses = res.data.courses; // TODO: change this
                this.setState({
                    courses: this.state.courses.concat(_courses),
                    coursePage: this.state.coursePage + 1,
                    hasNextCourse: res.has_next,
                    initCourses: true
                });
            };
        };
        searchCourses(this.state.query, this.state.coursePage).then(gen(target));
    }

    _appendInstructors(event) {
        let target = (event) ? event.target : null;
        if (target) {
            if (target.classList.contains('searching')) return;
            target.className += ' searching';
        }
        const gen = (elem) => {
            return (res) => {
                if (elem) elem.classList.remove('searching');
                if (!res) return;
                let _instructors = res.data.instructors; // TODO: change this
                this.setState({
                    instructors: this.state.instructors.concat(_instructors),
                    instructorPage: this.state.instructorPage + 1,
                    hasNextInstructor: res.has_next,
                    initInstructors: true
                });
            };
        };
        searchInstructors(this.state.query, this.state.instructorPage).then(gen(target));
    }

    _appendObjects() {
        this._appendCourses();
        this._appendInstructors();
    }

    _updateDimensions() {

    }

    componentDidMount() {
        // window.addEventListener("resize", this._updateDimensions);
        this._appendObjects();
    }

    render() {
        const departments = getAllDepartments();
        const courses = (!this.state.initCourses) ? (<div></div>) :
            ((this.state.courses.length > 0) ?
            this.state.courses.map((course) => (
                <Link key={course.id} to={'/course/' + course.id} className="search-result-link">
                    <div className="search-result-block">
                        <u>{ departments[course.department].short_title + " " + course.number }</u>
                        <br />
                         <span className="search-result-course-title">
                            { course.title }
                         </span>
                    </div>
                </Link>
            )) : (<div className="search-result-block">No course found.</div>));

        const instructors = (!this.state.initInstructors) ? (<div></div>) :
            ((this.state.instructors.length > 0) ?
            this.state.instructors.map((instructor) => (
                <Link key={instructor.eid_hash} to={'/instructor/' + instructor.eid_hash} className="search-result-link">
                    <div className="search-result-block">
                        <span className="search-result-highlight-instructor">{ instructor.name }</span>
                    </div>
                </Link>
            )) : (<div className="search-result-block">No instructor found.</div>));

        const moreInstructor = (this.state.hasNextInstructor) ?
            <div className="search-result-more" onClick={ this._appendInstructors.bind(this) }>■ More instructors</div> : '';
        const moreCourse = (this.state.hasNextCourse) ?
            <div className="search-result-more" onClick={ this._appendCourses.bind(this) }>■ More courses</div> : '';
        return (
            <div className="search-result-container">
                <div className="search-result-left">
                    { instructors }
                    { moreInstructor }
                </div>
                <div className="search-result-right">
                    { courses }
                    { moreCourse }
                </div>
            </div>
        );
    }

    componentDidUpdate() {
        if (this.props.query !== this.state.query) {
            this.setState({query: this.props.query, courses: [], instructors: [], hasNextCourse: false, hasNextInstructor: false,
            coursePage: 1, instructorPage: 1, initCourses: false, initInstructors: false}, this._appendObjects);
        }
    }

    componentWillUnmount() {
        // window.removeEventListener("resize", this._updateDimensions);
    }

}

export default SearchResultWrapper;


// WEBPACK FOOTER //
// ./src/components/SearchResultWrapper.js